import {Component, ElementRef, Injector, Optional, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {DatasetAwareComponent} from "../dataset-aware.component";

const DEFAULT_CLS = 'app-select-wrapper';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-select',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmSelect]',
  template: `<select role="listbox" aria-expanded="false" focus-target
                     [ngClass]="'app-select form-control'"
                     [required]="required"
                     [tabindex]="tabindex"
                     [(ngModel)]="modelByKey"
                     [multiple]="multiple"
                     [attr.name]="name"
                     [attr.aria-label]="hint || 'Select options'"
                     [attr.aria-multiselectable]="multiple"
                     [autofocus]="autofocus"
  >
    <option selected
            value="undefined"
            [textContent]="placeholder"
            [hidden]="!placeholder"></option>
    <ng-container *ngIf="groupby">
      <optgroup *ngFor="let groupObj of groupedData"
                [label]="groupObj.key">
        <option *ngFor="let item of groupObj.data;"
                [value]="item.key"
                [selected]="item.selected"
                [textContent]="item.label"
                role="option"></option>
      </optgroup>
    </ng-container>

    <ng-container *ngIf="!groupby">
      <option *ngFor="let item of datasetItems"
              [value]="item.key"
              [selected]="item.selected"
              [textContent]="item.label"
              role="option"></option>
    </ng-container>
  </select>`,
  providers: [
    provideAsWidgetRef(SelectComponent)
  ],
  exportAs: 'wmSelect',
  standalone: true,
  imports: [CommonModule, FormsModule],
  styles: []
})
export class SelectComponent extends DatasetAwareComponent {
  static initializeProps = register('wm-select');

  public placeholder: string;
  public navsearchbar: any;
  public class: string;
  public required: boolean;
  public name: string;
  public autofocus: boolean;
  public hint: string;
  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  override get stylerEl(): HTMLElement {
    return this.nativeElement.querySelector('select.app-select') || this.nativeElement;
  }
}

